import { render, staticRenderFns } from "./company-info-auth.vue?vue&type=template&id=2e68a099&scoped=true&"
import script from "./company-info-auth.vue?vue&type=script&lang=js&"
export * from "./company-info-auth.vue?vue&type=script&lang=js&"
import style0 from "./company-info-auth.vue?vue&type=style&index=0&id=2e68a099&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68a099",
  null
  
)

export default component.exports